import { render, staticRenderFns } from "./MInplayCartNew.vue?vue&type=template&id=b6be8794&scoped=true"
import script from "./MInplayCartNew.vue?vue&type=script&lang=js"
export * from "./MInplayCartNew.vue?vue&type=script&lang=js"
import style0 from "./MInplayCartNew.vue?vue&type=style&index=0&id=b6be8794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6be8794",
  null
  
)

export default component.exports